<template>

	<div class="section section-bold">
		<div class="section-title">
			{{title}}
			<span v-on:click="close" class="category-title-btn"><i class="material-icons md-14">close</i></span>
		</div>
		<form class="section-body">
			<div class="category">
				<div class="category-title overflow-hidden">
					DESCRIPTION
				</div>
				<div class="property-row">
					<input v-model.string="rec.description" class="form-control form-control-sm" placeholder="short description">
				</div>
				<div class="category-title overflow-hidden">
					URL
				</div>
				<div class="property-row">
					<input v-model.string="rec.url" class="form-control form-control-sm" placeholder="full URL">
				</div>
			</div>
		</form>
		<div class="section-footer">
			<button v-on:click="submit" class="btn btn-sm btn-primary float-right">{{submitLabel}}</button>
		</div>
	</div>
</template>
<script>

export default {
	name: 'reference-form',
	created: function(){
		if (this.reference) this.rec = JSON.parse(JSON.stringify(this.reference))
		else this.rec = {}
	},
	components:{
	},
	data:function(){
		return {
			rec:{}
		}
	},
	methods:{
		close:function(){
			this.$emit('close');
		},
		submit:function(){
			this.$emit('submit',this.rec);
		},
	},
	props:{
		reference:{
			description: String,
			url: String,
		},
		submitLabel:String,
		title:String,

	},
	watch:{
	}
}

</script>





// WEBPACK FOOTER //
// src/components/community-plan/reference-form.vue